import { MemberSearchField } from '@/domain/use-cases/audiences/member-list';

export const searchOptions: { label: string; value: MemberSearchField }[] = [
  { label: 'Documento', value: 'document' },
  { label: 'Nombre', value: 'name' },
  { label: 'Apellido', value: 'lastname' },
  { label: 'Email', value: 'email' },
  { label: 'Área', value: 'area' },
  { label: 'Departamento', value: 'department' },
  { label: 'Cargo', value: 'position' },
  { label: 'Unidad', value: 'unit' },
];

export const plural = (count: number, one: string, many: string) =>
  count === 1 ? one : many;
